"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoadsideNumberEntity = void 0;
const BadRequestError_1 = require("../GS/BadRequestError");
const validators_1 = require("../GS/validators");
const LocationEntity_1 = require("../locations/LocationEntity");
const ManufacturerDto_1 = require("../manufacturers/ManufacturerDto");
const ManufacturerEntity_1 = require("../manufacturers/ManufacturerEntity");
const RoadsideNumberDto_1 = require("./RoadsideNumberDto");
const SingleEntityBase_1 = require("../GS/SingleEntityBase");
const ValidationError_1 = require("../GS/ValidationError");
class RoadsideNumberEntity extends SingleEntityBase_1.SingleEntityBase {
    constructor(dependencies, roadsideNumber) {
        super();
        this._requiredFieldsSetStatus = {
            name: false,
            number: false
        };
        this._dependencies = dependencies;
        if (roadsideNumber === undefined) {
            this._dto = new RoadsideNumberDto_1.RoadsideNumberDto();
        }
        else if (roadsideNumber instanceof RoadsideNumberDto_1.RoadsideNumberDto) {
            this._dto = new RoadsideNumberDto_1.RoadsideNumberDto(roadsideNumber);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else if (roadsideNumber instanceof RoadsideNumberEntity) {
            this._dto = new RoadsideNumberDto_1.RoadsideNumberDto(roadsideNumber._dto);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else {
            throw new Error("Invalid arg");
        }
    }
    toDto() {
        return new RoadsideNumberDto_1.RoadsideNumberDto(this._dto);
    }
    getId() {
        return this._dto.id;
    }
    getManufacturer() {
        if (this._dto.manufacturerId === undefined) {
            return undefined;
        }
        if (this._dto.location === undefined) {
            throw new Error("Cannot call getManufacturer without first loading the Manufacturer.");
        }
        if (!this._manufacturerEntity && this._dto.manufacturer) {
            this._manufacturerEntity = new ManufacturerEntity_1.ManufacturerEntity(this._dependencies, this._dto.manufacturer);
        }
        return this._manufacturerEntity;
    }
    setManufacturer(untrustedValue) {
        let untrustedId;
        if (untrustedValue instanceof ManufacturerEntity_1.ManufacturerEntity) {
            if (untrustedValue.isNew) {
                throw new BadRequestError_1.BadRequestError("untrustedValue.isNew cannot be true.");
            }
            untrustedId = untrustedValue.getId();
        }
        else if (untrustedValue instanceof ManufacturerDto_1.ManufacturerDto) {
            untrustedId = untrustedValue.id;
        }
        else {
            throw new BadRequestError_1.BadRequestError("untrustedValue is of an invalid type.");
        }
        this.setManufacturerId(untrustedId);
        if (this.hasError("manufacturerId")) {
            return;
        }
        if (untrustedValue instanceof ManufacturerEntity_1.ManufacturerEntity) {
            this._manufacturerEntity = untrustedValue;
        }
    }
    getManufacturerId() {
        return this._dto.manufacturerId;
    }
    setManufacturerId(untrustedValue) {
        let _untrustedValue;
        this.clearError("manufacturerId");
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("manufacturerId", "Manufacturer Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (!this.isNew && _untrustedValue === this._dto.manufacturerId) {
            return;
        }
        this._dto.manufacturerId = _untrustedValue;
        delete this._manufacturerEntity;
        this._setIsDirty(true);
    }
    getLocation() {
        if (this._dto.locationId === undefined) {
            return undefined;
        }
        if (this._dto.location === undefined) {
            throw new Error("Cannot call getLocation without first loading the Location.");
        }
        if (!this._locationEntity && this._dto.location) {
            this._locationEntity = new LocationEntity_1.LocationEntity(this._dependencies, this._dto.location);
        }
        return this._locationEntity;
    }
    setLocation(untrustedValue) {
        let untrustedId;
        if (untrustedValue instanceof ManufacturerEntity_1.ManufacturerEntity) {
            if (untrustedValue.isNew) {
                throw new BadRequestError_1.BadRequestError("untrustedValue.isNew cannot be true.");
            }
            untrustedId = untrustedValue.getId();
        }
        else if (untrustedValue instanceof ManufacturerDto_1.ManufacturerDto) {
            untrustedId = untrustedValue.id;
        }
        else {
            throw new BadRequestError_1.BadRequestError("untrustedValue is of an invalid type.");
        }
        this.setLocationId(untrustedId);
        if (this.hasError("locationId")) {
            return;
        }
        if (untrustedValue instanceof LocationEntity_1.LocationEntity) {
            this._locationEntity = untrustedValue;
        }
    }
    getLocationId() {
        return this._dto.locationId;
    }
    setLocationId(untrustedValue) {
        let _untrustedValue;
        this.clearError("locationId");
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("locationId", "Location Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (!this.isNew && _untrustedValue === this._dto.locationId) {
            return;
        }
        this._dto.locationId = _untrustedValue;
        delete this._locationEntity;
        this._setIsDirty(true);
    }
    getName() {
        return this._dto.name;
    }
    setName(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("name");
        this._requiredFieldsSetStatus.name = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("name", "Name is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("name", `Name has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.name) {
            return;
        }
        this._dto.name = _untrustedValue;
        this._setIsDirty(true);
    }
    getNumber() {
        return this._dto.number;
    }
    setNumber(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("number");
        this._requiredFieldsSetStatus.number = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("number", "Number is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("number", `Number has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.number) {
            return;
        }
        this._dto.number = _untrustedValue;
        this._setIsDirty(true);
    }
    getTypeOfIcon() {
        return this._dto.typeOfIcon;
    }
    setTypeOfIcon(untrustedValue) {
        const maxLength = 25;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("typeOfIcon");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("typeOfIcon", `Type Of Icon has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.typeOfIcon) {
            return;
        }
        this._dto.typeOfIcon = _untrustedValue;
        this._setIsDirty(true);
    }
    getManufacturerIconId() {
        return this._dto.manufacturerIconId;
    }
    setManufacturerIconId(untrustedValue) {
        let _untrustedValue;
        this.clearError("manufacturerIconId");
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("manufacturerIconId", "Manufacturer Icon Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (!this.isNew && _untrustedValue === this._dto.manufacturerIconId) {
            return;
        }
        this._dto.manufacturerIconId = _untrustedValue;
        this._setIsDirty(true);
    }
    getIconFileName() {
        return this._dto.iconFileName;
    }
    setIconFileName(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("iconFileName");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("iconFileName", `Icon File Name has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.iconFileName) {
            return;
        }
        this._dto.iconFileName = _untrustedValue;
        this._setIsDirty(true);
    }
    getIconContentType() {
        return this._dto.iconContentType;
    }
    setIconContentType(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("iconContentType");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("iconContentType", `Icon Content Type has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.iconContentType) {
            return;
        }
        this._dto.iconContentType = _untrustedValue;
        this._setIsDirty(true);
    }
    getIconFileSize() {
        return this._dto.iconFileSize;
    }
    setIconFileSize(untrustedValue) {
        let _untrustedValue;
        this.clearError("iconFileSize");
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 0 })) {
            this.addError(new ValidationError_1.ValidationError("iconFileSize", "Icon File Size is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (!this.isNew && _untrustedValue === this._dto.iconFileSize) {
            return;
        }
        this._dto.iconFileSize = _untrustedValue;
        this._setIsDirty(true);
    }
    getPosition() {
        return this._dto.position;
    }
    setPosition(untrustedValue) {
        let _untrustedValue;
        this.clearError("position");
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue)) {
            this.addError(new ValidationError_1.ValidationError("position", "Position is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (!this.isNew && _untrustedValue === this._dto.position) {
            return;
        }
        this._dto.position = _untrustedValue;
        this._setIsDirty(true);
    }
    getposition() {
        return this._dto.manufacturerIconId;
    }
    getIconUpdatedAt() {
        return this._dto.iconUpdatedAt;
    }
    getCreatedAt() {
        return this._dto.createdAt;
    }
    getUpdatedAt() {
        return this._dto.updatedAt;
    }
    loadManufacturerAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                if (!this.getManufacturerId()) {
                    return;
                }
                this._emit("before-loadManufacturerAsync");
                this._dto.manufacturer = yield this._dependencies.manufacturerDatastore
                    .getAsync(this.getManufacturerId());
                delete this._manufacturerEntity;
                this._emit("after-loadManufacturerAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    loadLocationAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                if (!this.getLocationId()) {
                    return;
                }
                this._emit("before-loadLocationAsync");
                this._dto.location = yield this._dependencies.locationDatastore
                    .getAsync(this.getLocationId());
                delete this._locationEntity;
                this._emit("after-loadLocationAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    loadAsync(id, expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (typeof id === "string") {
                    if (!validators_1.isInt(id, { min: 1 })) {
                        throw new BadRequestError_1.BadRequestError("ID is not valid.");
                    }
                    id = parseInt(id, 10);
                }
                this._setState("busy");
                this._emit("before-loadAsync");
                this._dto = yield this._dependencies.roadsideNumberDatastore
                    .getAsync(id, expand);
                delete this._manufacturerEntity;
                delete this._locationEntity;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._clearAllRequiredFieldsSetStatuses();
                this.clearErrors();
                this._emit("after-loadAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    saveAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-saveAsync");
                if (!this.allRequiredFieldsSet) {
                    const fields = Object.entries(this._requiredFieldsSetStatus)
                        .filter(([, isSet]) => !isSet).map(([field]) => field);
                    throw new Error(`The following required fields were never set: ${fields.join(", ")}`);
                }
                if (!this.canSave) {
                    throw new Error("Roadside Number is not in a valid state.");
                }
                let dto = this.toDto();
                if (this.isNew) {
                    dto = yield this._dependencies.roadsideNumberDatastore
                        .addAsync(this._dto);
                }
                else if (this.isDirty) {
                    dto = yield this._dependencies.roadsideNumberDatastore
                        .updateAsync(this._dto);
                }
                this._dto.id = dto.id;
                this._dto.createdAt = dto.createdAt;
                this._dto.updatedAt = dto.updatedAt;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._emit("after-saveAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    deleteAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-deleteAsync");
                if (!this.canDelete) {
                    throw new Error("Roadside Number cannot be deleted.");
                }
                if (!this.isNew) {
                    yield this._dependencies.roadsideNumberDatastore
                        .removeAsync(this.getId());
                }
                this._emit("after-deleteAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
}
exports.RoadsideNumberEntity = RoadsideNumberEntity;
//# sourceMappingURL=RoadsideNumberEntity.js.map